import { Injectable } from '@angular/core';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { Computed, StateRepository } from '@angular-ru/ngxs/decorators';
import { State } from '@ngxs/store';
import { ReachLab, ReachLabService } from '@portals/api';

import { finalize, mergeMap, tap } from 'rxjs/operators';

interface StateModel {
	isLoading: boolean;
	data: Array<ReachLab>;
	selected: ReachLab;
}

@StateRepository()
@State<StateModel>({
	name: 'labs',
})
@Injectable()
export class ReachLabsState extends NgxsDataRepository<StateModel> {
	@Computed()
	get isLoading() {
		return this.snapshot.isLoading;
	}

	@Computed()
	get hasData() {
		return !!this.snapshot.data;
	}

	@Computed()
	get data() {
		return this.snapshot.data;
	}

	@Computed()
	get item() {
		return this.snapshot.selected;
	}

	constructor(private reachLabService: ReachLabService) {
		super();
	}

	load() {
		this.patchState({ isLoading: true });

		return this.reachLabService.find({ params: { sort: 'createdAt:desc' } }).pipe(
			tap(({ data }) => {
				data = data.filter((lab) => lab.active === true);
				this.patchState({ data });
			}),
			finalize(() => {
				this.patchState({ isLoading: false });
			})
		);
	}

	findOne(id: number) {
		return this.reachLabService.findOneById(id, { skipInterceptor: true });
	}

	findOneByUUID(uuid: string) {
		return this.reachLabService.findOneByUUID(uuid, {
			skipInterceptor: true,
		});
	}

	create(payload: FormData) {
		this.patchState({ isLoading: true });

		return this.reachLabService.create(payload).pipe(mergeMap(() => this.load()));
	}

	update(id: number, formData: FormData) {
		this.patchState({ isLoading: true });

		return this.reachLabService.update(id, formData).pipe(mergeMap(() => this.load()));
	}
}
